import { useMemo } from 'react'

import { useGetTrackedGamesQuery } from '../../../api/core'
import { useGetAvailableAISummariesForGamesQuery } from '../../../api/live-event-predictions'
import { useCurrentUserLanguage } from '../../account/hooks/useCurrentUserLanguage'

type UseTrackedGamesHookParams = {
  include?: string[]
  eventTypes?: string[]
}

export const useTrackedGames = ({ eventTypes }: UseTrackedGamesHookParams) => {
  const userLanguage = useCurrentUserLanguage()
  const aiSummariesForGames = useGetAvailableAISummariesForGamesQuery()
  const trackedGames = useGetTrackedGamesQuery({ eventTypes, userLanguage })

  const trackedGamesData = useMemo(() => {
    if (!trackedGames.data) return []

    return trackedGames.data.map((game) => {
      const aiSummaryForGame = aiSummariesForGames.data?.find((summary) => summary.gameId === game.game.id)
      return { ...game, aiSummariesAvailable: aiSummaryForGame ? aiSummaryForGame.prompts : [] }
    })
  }, [trackedGames.data, aiSummariesForGames.data])

  return {
    data: trackedGamesData,
    isLoading: trackedGames.isLoading,
    isFetching: trackedGames.isFetching,
    error: trackedGames.error,
    isError: trackedGames.isError,
  }
}
